// Libarary
import { Injectable } from '@angular/core';
import { ConfigService } from './../../infrastructure/config.service';
import { NetworkService } from './../../infrastructure/network.service';

@Injectable()
export class ReleaseItemsAuditService {
  constructor(public configService: ConfigService,
    private networkService: NetworkService) {
  }

  // Get Dealer Account List
  public getReleaseItemsAuditAccountList() {
    return this.networkService.getRequest(this.configService.getDealerAuditAccountListUrl());
  }

  // Get Release Items Audit Log
  public getReleaseItemsAudit(productFilters) {
    return this.networkService.postRequest(this.configService.getReleaseItemsAuditLogUrl(), productFilters);
  }
}
